export const ApprovalRuleType = {
  /** All approve */
  AllApprove: 'all_approve',
  /** Any one approval */
  AnyOneApprove: 'any_one_approve',
  /** Majority approves */
  MajorityApprove: 'majority_approve',
} as const;

export type ApprovalRuleType =
  (typeof ApprovalRuleType)[keyof typeof ApprovalRuleType];
